export default RAILS_ASSET_URL("/gallery-image-08.webp")
